import { createContext, useState, useRef } from "react";
import moment from "moment";
import useAuth from "../hooks/useAuth";
import useGlobalParams from "../hooks/useGlobalParams";

const GeneralPositionContext = createContext({});

export const GeneralPositionProvider = ({ children }) => {
  // Load context values
  const { auth } = useAuth();
  const { globalparams } = useGlobalParams();

  // Init values
  const positionInit = { posDate: moment().format("yyyy-MM-DD"), tolerance: "10.00%", quantity: "" };
  const positionDataInit = { posDate: moment().format("yyyy-MM-DD"), tolerance: 0.1, quantity: null };
  const containerInit = [{ incoterm: "FOB", port: "", bagSize: "", marks: "", price: "", shipFrom: "", shipTo: "" }];
  const containerDataInit = [
    { incotermID: 4, portID: "", bagSizeID: "", marks: "", price: "", shipFrom: "", shipTo: "" },
  ];
  const bulkInit = [{ incoterm: "FOB", port: "", bagSize: "", marks: "", price: "", shipFrom: "", shipTo: "" }];
  const bulkDataInit = [{ incotermID: 4, portID: "", bagSizeID: "", marks: "", price: "", shipFrom: "", shipTo: "" }];
  const paytermInit = [{ portion: "0%", payType: "CAD", termdays: "10" }];
  const paytermDataInit = [{ portion: 0, payTypeID: 1, termdays: 10 }];

  // States
  const [position, setPosition] = useState(positionInit);
  const [positionData, setPositionData] = useState(positionDataInit);

  return (
    <GeneralPositionContext.Provider
      value={{
        positionInit,
        positionDataInit,
        containerInit,
        containerDataInit,
        bulkInit,
        bulkDataInit,
        paytermInit,
        paytermDataInit,
        position,
        setPosition,
        positionData,
        setPositionData,
      }}
    >
      {children}
    </GeneralPositionContext.Provider>
  );
};

export default GeneralPositionContext;
